import { Project } from '../types';

export const getProjectsByStatus = (projects: Project[], status: string) => {
  return projects.filter((project) => project.status === status);
};

export const getProjectById = (projects: Project[], id: string) => {
  return projects.find((project) => project.id === id);
};
